import React from 'react';
import Loader from '../../../utils/Loader';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { htmlEncode, getFullname } from '../../../utils/commonFunctions';
import { formatDateNew, formatDateTime } from '../../../utils/commonFunctions';

const LiveClass = ({ live_classes, courseid }) => {

    const liveClassURL = `https://payment.steptest.in/liveclass/user.php?`
    const todayDate = (new Date()).getDate()
    const todayYear = (new Date()).getFullYear()

    const isFirstUpcomingFound = { value: false }

    function updateRowStatus(itemDate) {
        if ((new Date(itemDate)).getDate() >= todayDate && (new Date(itemDate)).getFullYear() >= todayYear && isFirstUpcomingFound.value === false) {
            isFirstUpcomingFound.value = true
            return true
        } else {
            return false
        }
    }

    return (
        <>
            <table className='table callHistory'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Topic</th>
                        <th>Start Date and Time</th>
                        <th>Add a Reminder</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {live_classes.map((element, index) => {
                        return (
                            <tr className={updateRowStatus(element.start_date) ? 'highlight-row' : ''}>
                                <td>{index + 1}</td>
                                <td>{element.topic}</td>
                                <td>{`${formatDateNew(element.start_date, 'D MMMM yyyy')}, ${formatDateTime(
                                    element.start_date,
                                    'hh:mm A',
                                )}`}</td>
                                <td>
                                    {(new Date(element.start_date)).getDate() >= todayDate && (new Date(element.start_date)).getFullYear() >= todayYear && (
                                        <a target="_blank" href="https://calendar.google.com/calendar/event?action=TEMPLATE&amp;tmeid=NnB1MzZjNDFuZ2JlMWEyNmtubnU4OHE4dDQgcGFuZGlhcmFqYW4ua3ZAbQ&amp;tmsrc=pandiarajan.kv%40gmail.com" className='googleCalendar'>
                                            <img src="/assets/img/google-calendar.png" alt="Google Calendar" />
                                        </a>
                                    )}
                                </td>
                                <td>
                                    <a
                                        href={`${liveClassURL}mid=${element.topic_id}&mname=${htmlEncode(element.topic)}&uname=${htmlEncode(getFullname())}&courseId=${htmlEncode(localStorage.getItem('active_course_id'))}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >{(new Date(element.start_date)).getDate() >= todayDate && (new Date(element.start_date)).getFullYear() >= todayYear ? 'Join Class' : 'Watch Replay'}</a>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}

const mapStateToProps = (state) => {
    const { courseid } = state.rootReducer.myCourse;
    const { live_classes } = state.rootReducer.myCourse.coursedetails;

    return {
        live_classes,
        courseid
    };
}

export default compose(connect(mapStateToProps))(LiveClass);